import {api, routes} from "@/plugins/axios";

export function useFiles() {
    const createFile = (organizationSlug, formData) => {
        return api.post(routes.files.create(organizationSlug), formData)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    };

    const deleteFile = (organizationSlug, fileName) => {
        return api.delete(routes.files.delete(organizationSlug, fileName))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const downloadFile = (organizationSlug, fileName, title = null) => {
        return api.get(routes.files.download(organizationSlug, fileName), { responseType: 'blob' }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            if(title && title !== '') {
                link.setAttribute('download', title);
            } else {
                link.setAttribute('download', fileName);
            }
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return Promise.resolve();
        }).catch((err) => {
            return Promise.reject(err);
        });
    }



    return {
        createFile,
        downloadFile,
        deleteFile
    }
}
